import { NgModule } from '@angular/core';
import { MatToolbarModule } from '@angular/material/toolbar';
import { ExperimentComponent } from '@components/experiment/experiment.component';
import { ExperimentContentModule } from '@components/experiment-content/experiment-content.module';

@NgModule({
    declarations: [ExperimentComponent],
    exports: [ExperimentComponent],
    imports: [ExperimentContentModule, MatToolbarModule]
})
export class ExperimentModule { }